module.exports = __webpack_public_path__ + "img/让座.0f9deeba.png";